import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrganization } from "./useOrganization";

export function useFeatureFlags() {
  const { organization } = useOrganization();
  const orgId = organization?.id ?? null;

  const { data: flags, isLoading: queryLoading } = useQuery({
    queryKey: ["feature-flags", orgId],
    queryFn: async () => {
      const { data } = await supabase
        .from("feature_flags")
        .select("*")
        .eq("organization_id", orgId!)
        .maybeSingle();
      return data;
    },
    enabled: !!orgId,
  });

  const isEnabled = (feature: string): boolean => {
    if (!flags) return false;
    return (flags as any)[`${feature}_enabled`] ?? false;
  };

  // Report "loading" while organization context is still being resolved.
  // Without this composition, useQuery's enabled:!!orgId gate causes
  // queryLoading:false during the org-pending boot window — yet `flags` is
  // still undefined, so isEnabled() returns false. Downstream consumers
  // (FeatureRoute via decideFeatureGate) would then fire a spurious
  // <Navigate to="/" replace /> for any player-route feature check during
  // a cold full-page boot. See
  // audit-reports/investigations/leagues-redirect-findings.md.
  const isLoading = !orgId || queryLoading;

  return { flags, isLoading, isEnabled };
}
